<template>
  <el-tooltip class="item" effect="dark" :content="`转发${appNameLabel}给好友`" placement="right-start">
    <div class="client-share" @click="copy">
      <div><img :src="shareIcon" alt="" /></div>
      <span>爱心转发</span>
    </div>
  </el-tooltip>
</template>

<script>
import copy from "copy-to-clipboard";
import {WinForm,AppName,AppClientDownPath} from '@digital-supply-chain/module'
import {DomainService} from '@/libs'
import {Message} from '@/service'

export default {
  data() {
    return {
      shareIcon: `${DomainService.PublicPath}resource/images/icon/aixin.png`,
      appNameLabel: (WinForm.md.getAppNameLabel() || '大国工匠'),
    }
  },
  methods: {
    copy() {
      if (copy(AppClientDownPath[WinForm.md.getAppName()] || "https://down.global-dsc.cn/Release/dggj/dggj.exe")) {
        Message.success(`${this.appNameLabel}下载地址复制成功，可以转发给好友使用`);
      } else {
        Message.error("复制失败");
      }
    },
  }
}
</script>

<style lang="less" scoped>
  .client-share{
    width: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: #0989C5;
    line-height: 18px;
    // position: absolute;
    // left: 0;
    // top: 0;
    // z-index: 1000;
    cursor: pointer;
    outline: none;
    img{
      width: 30px;
      height: 30px;
    }
  }
</style>
